<template>
  <div class="overlay-info">
    <div class="overlay-header hide-portrait" @click="close()" :class="{'active': banner !== ''}"><img v-if="banner !== ''" :src="banner"/></div>
    <div class="overlay-content">
        <div class="overlay-info-header topbar-container drop-shadow">
            <Icon name="logo"></Icon>
            <h2 class="overlay-content-title hide-portrait">{{title}}</h2>
            <div class="flex-spacer"></div>
            <button class="btn btn-close hide-landscape" @click="close()">
                <label data-translation-element="close">Sulge</label>
                <div class="circle"><Icon name="close"/></div>
            </button>
        </div>
        <div class="overlay-header hide-landscape" @click="close()" v-show="banner !== ''" :class="{'active': banner !== ''}"><img v-if="banner !== ''" :src="banner"/></div>
        <div class="overlay-info-content">
            <slot/>
        </div>
    </div>
    <div class="overlay-footer hide-portrait" @click="close()">
        <button class="btn btn-close" >
            <label data-translation-element="close">Sulge</label>
            <div class="circle"><Icon name="close"/></div>
        </button>
    </div>
  </div>
</template>

<script>
export default {
    props: {
		title: {
			type: String,
			default: ""
		},
        banner: {
            type: String,
            default: ''
        }
    },
    computed: {
        hasBanner () {
            return false;
        }
    },
    methods: {
        close () {
            console.log('close')
            this.$emit("close");
        },
        translate (key, params) {
			return this.$wayfinder.translator.get(key, params)
		}
    }
}
</script>

<style lang="less">
    @import '../css/variables';
    @import '../css/responsive';
    
    .overlay-info {
        top: 100%;
        bottom: 0;
        position: absolute;
        overflow: hidden;
        width: 100%;   
        z-index: 2;
        transition: top 0.3s ease-out;
        display: none;
        flex-direction: column;

        &.active {
            top: 0 !important;
            display: flex;
        }
    }

    .overlay-info-container {
        height: 40vh;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .overlay-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .overlay-info-content {
        height: 100%;
        background-color: white;
    }

    .overlay-info-header {
        background-color: white;
        flex-basis: @top-bar-height !important;
        justify-content: space-evenly;
        flex-direction: row !important;
        align-items: center;
        z-index: 1;
        flex-grow: 0;
        flex-shrink: 0;
        
        .icon-logo {
            --color1: rgba(52, 56, 71, 1);
            height: 2rem;
            margin-right: 1.6rem;
        }
    }

    .overlay-header {
        flex-basis: 35.5rem;
        flex-grow: 0;
        flex-shrink: 0;
        z-index: 0;

        opacity: 0;
        transition: opacity 0.3s ease-out;

        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }

        &.active {
            opacity: 1;
        }
    }

    .overlay-content-title {
        font-size: 2.4rem;
    }

    .btn-close {
        display: flex;
        align-items: center;
        background-color: transparent !important;

        .circle {
            //border: 0.2rem solid rgba(224, 223, 223, 1);
            background-color: @active-color;
            border-radius: 50%;
            width: 3.6rem;
            height: 3.6rem;
            margin-left: 0.8rem;
            display: flex;
            justify-content: center;
            align-items: center;
            
        }
        label {
            font-size: 1.6rem;
        }
        .icon {
            --color1: white;
            height: 1.6rem !important;
            margin: auto;
        }
    }

    .overlay-header-poi {
        font-size: 1.4rem;
        font-weight: 500;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .icon {
            height: 1.4rem;
            margin-right: 0.8rem;
            --color1: #A7A9AC;
        }

        & > div {
            margin-left: 2.4rem;
        }
    }

    .overlay-footer  {
        display: flex;
        flex-basis: 6.4rem;
        flex-grow: 0;
        flex-shrink: 0;
        background-color: #FAF9F8;
        justify-content: flex-end;
        align-items: center;
        border-top: 0.2rem solid @border-color;
        
    }

    .wf-tab {
        background-color: white;
    }

    @media @portrait {
        .overlay-info {
            flex-direction: column-reverse;
            z-index: 3;
        }

        .overlay-info-content {
            overflow: hidden;
        }

        .overlay-info-header {
            padding-left: 7.2rem;
            padding-right: 7.2rem;
        }

        .overlay-background {
            height: 34vh + 20vh !important;
        }

        .overlay-info-container {
            padding-bottom: 2.8rem;
        }

        .overlay-header {
            flex-basis: 16rem;
            flex-grow: 0;
            flex-shrink: 0;
            overflow: hidden;
        }

        .overlay-footer-portrait {
            flex-basis: 2.9rem;
            flex-grow: 0;
            flex-shrink: 0;
            background-color: white;
            z-index: 1;
        }

        .wf-page {
            font-size: 2rem !important;
        }
    }

    @media @landscape {
        .overlay-content-container {
            padding: 2.4rem !important;

            .wf-page {
                margin-right: 0 !important;
            }

            .wf-page-item {
                p:first-child {
                    margin-block-start: 0;
                }
            }
        }
        .overlay-info {
            &.active {
                bottom: 8rem;
            }
            .overlay-info-container {
                width: 34%;
                right: 0;
                top: 0;
                height: 100%;
            }

            .overlay-info-header {
                padding-left: 2.4rem;
                padding-right: 2.4rem;
            }
        }
    }
</style>